import Image from 'next/image'

import { getImageUrl } from '@/lib/utils'

import type { ContentfulAsset } from '@/lib/contentful-api'

export function HalfHalfBlockMedia({ image, video, priority = false }: { image?: ContentfulAsset; video?: ContentfulAsset; priority?: boolean }) {
  if (image) {
    return (
      <Image
        src={getImageUrl(image)}
        alt={image?.fields?.title ?? 'Section Half Half'}
        width={image?.fields?.file?.details?.image?.width}
        height={image?.fields?.file?.details?.image?.height}
        sizes="(max-width: 768px) 100vw, 50vw"
        className="h-auto w-full rounded-3xl object-cover"
        priority={priority}
      />
    )
  }

  if (video) {
    return (
      <video className="size-full rounded-3xl object-cover" controls preload="metadata">
        <source src={`https:${video?.fields?.file?.url}`} type={video?.fields?.file?.contentType} />
        Your browser does not support the video tag.
      </video>
    )
  }

  return null
}
